import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import { RatingAPI } from '../../../constants/API';
import { commonHeaders } from '../../../constants/HeadersAPI';

export const useDeleteRatingMedia = (branchQueueId: number | null) => {
  const queryClient = useQueryClient();
  return useMutation(
    (mediaId: number) =>
      axios.delete(RatingAPI.deleteMedia(branchQueueId!, mediaId), commonHeaders()),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['ratingSettings', branchQueueId]);
      }
    }
  );
};
